import { get, patch, upload } from '../../utils/api'
import { AxiosResponse } from 'axios'

export const fetchAchievement = (id: string): Promise<AxiosResponse> =>
  get(`/achievements/achievements/${id}`, {
    include: 'imageMedia,userAchievement,userAchievementsCount',
  })

export const editAchievement = (
  id: string,
  status: string,
  caption: string,
  requirements: string,
  description: string,
  shareDescription: string,
  image?: File
): Promise<AxiosResponse> => {
  return image
    ? upload(
        `/achievements/achievements/${id}`,
        {
          field: 'image',
          item: image,
        },
        {
          _method: 'PATCH',
          id,
          status,
          caption,
          requirements,
          description,
          share_description: shareDescription,
        }
      )
    : patch(`/achievements/achievements/${id}`, {
        id,
        status,
        caption,
        requirements,
        description,
        share_description: shareDescription,
      })
}

export const fetchUsersCount = (): Promise<AxiosResponse> => get('/users/count')
